import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { NoteService } from '../../services/note/note.service';
import { UserService } from '../../services/user/user.service';
import { ConfigService } from '../../services/config/config.service';
import { AccountService } from '../../services/account/account.service';
import { DisplayService } from '../../services/display/display.service';
import { TabService } from '../tab/tab.service';
import { AddonService } from '../../services/addon/addon.service';
import { DataTableService } from '../../services/dataTable/dataTable.service';
@Injectable()
export class ContractorService {
	loadContractorPOsCompleted: EventEmitter<any> = new EventEmitter();

	dataObj = 'contractor';
	poDataObj = 'po-contractor';
	dataConfig: any = {};
	tableConfig = {};
	shortTableConfig = {};

	pendingDataObj = 'contractor-pending';
	migrateDataObj = 'contractor-migrate';
	migrateTSDataObj = 'contractor-migrateTS';
	migratePageSize = 5;
	loadingMigrateContractors = false;

	objString = 'Contractors';
	objRoot = 'contractor';
	listRoot = 'contractors';

	activePO;

	makingEdits = false;
	editingId = '';
	editingSupId = '';

	files;
	fileUploadMessage = '';
	fileUploadSuccessMessage = '';
	showContractorSubmissionModal = false;
	contractorBulkData: any;

	tabsData = {
		tabs: [
			{
				prop: 'full',
				name: 'Full Record',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: false,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'myedits',
				name: 'My Edits',
				active: false,
				persona: ['all'],
				notPersona: ['readonly', 'fa'],
				cached: false,
				listTab: false,
				statusTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'myapprovals',
				name: 'My Approvals',
				active: false,
				persona: ['all'],
				notPersona: ['readonly', 'fa'],
				cached: false,
				listTab: false,
				statusTab: true,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		listTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'any',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All Active',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'archive',
				name: 'Inactive',
				active: false,
				persona: ['pm', 'sam', 'cca', 'tra', 'fa', 'srm'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'cancellation',
				name: 'Cancelled',
				active: false,
				persona: ['pm', 'sam', 'cca', 'tra', 'readonly', 'fa'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: true,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		poListTabs: [
			{
				prop: 'pending',
				name: 'Pending',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'po',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		migrateListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'migrate',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		],
		migrateTSListTabs: [
			{
				prop: 'all',
				name: 'All',
				active: true,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'migrateTS',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	approvalFlags = {
		pm: {
			edits: 'supplierapprovalstatus',
			approvals: 'buyerapprovalstatus'
		},
		sam: {
			edits: 'buyerapprovalstatus',
			approvals: 'supplierapprovalstatus'
		},
		cca: {
			edits: 'supplierapprovalstatus',
			approvals: 'buyerapprovalstatus'
		}
	};

	showApprovals = true;

	approvalValues = {
		approved: 'approved',
		pending: 'pending'
	};

	awaitingContractorPOs = false;

	partialSuccessTitle = 'Contractors Move to Inactive/Restore Error(s)';
	errorMsg = 'Some of the selected contractors failed moving to inactive/restoring.  See the table below for details.';
	successMsg = 'The following contractors were moved to inactive tab/restored successfully.';
	errorDataObj = 'contractorerror';
	successDataObj = 'contractorsuccess';
	showErrorContractors = false;
	showSuccessContractors = false;

	rejectWarrantyConfirmation = "This rejection will only prevent the warranty from being enacted. The other contractor properties will stay the same and the contractor record will return to it's previous approval state.";
	approveWarrantyConfirmation = "Are you sure? Approving this warranty update will make the timesheets on the PO warrantied, prevent the contractor from submitting further timesheets, and make this PO non billable to IBM.";

	constructor(
		private router: Router,
		private commsService: CommsService,
		private dataService: DataService,
		private noteService: NoteService,
		private userService: UserService,
		private configService: ConfigService,
		private accountService: AccountService,
		private displayService: DisplayService,
		private tabService: TabService,
		private addonService: AddonService,
		private dataTableService: DataTableService
	) { }


	// TABBING METHODS

	getAllTab() {
		return this.tabsData.listTabs[1];
	}

	getPOAllTab() {
		return this.tabsData.poListTabs[1];
	}

	getPOPendingTab() {
		return this.tabsData.poListTabs[0];
	}

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							window.history.replaceState({}, '', '/contractors/' + tabProp);
							self.loadContractorsForTab(d);
							break;
						case 'po':
							self.loadPOContractorsForTab(d);
							break;
					}
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadContractorsForTab(d);
							break;
						case 'po':
							self.loadPOContractorsForTab(d);
							break;
						case 'migrate':
							self.updatePageDataForTab(d);
							break;
					}
				}
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					switch (d.type) {
						case 'standard':
							self.loadContractorsForTab(d);
							break;
						case 'po':
							self.loadPOContractorsForTab(d);
							break;
						case 'migrate':
							self.updatePageDataForTab(d);
							break;
					}
				}
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	resetTabs() {
		this.tabsData.tabs.forEach(function (d, i) {
			delete d['done'];
			delete d['undone'];
		});
		console.log('ORIGINAL TABS: ', this.tabsData);
	}

	checkTabs(tabsData) {
		if (tabsData === this.tabsData.tabs) {
			this.resetTabs();
			this.checkEditsStatus();
			this.checkApprovalsStatus();
		}

		console.log('CONTRACTOR TABS: ', this.tabsData);
	}

	checkEditsStatus() {
		const persona = this.userService.persona;
		console.log('CHECK EDIT STATUS', persona, this.approvalFlags[persona], this.dataService.poContractorDetails, this.dataService.contractorDetails);
		if (this.approvalFlags[persona] !== undefined) {
			this.showApprovals = true;
			let contractorData = this.dataService.poContractorDetails;
			if (contractorData === null) {
				contractorData = this.dataService.contractorDetails;
			}
			let editsApproved = false;
			let editsDone = false;

			if (contractorData.approval[this.approvalFlags[persona].edits] === this.approvalValues.approved) {
				editsApproved = true;
			}

			if (contractorData.approval[this.approvalFlags[persona].edits] === this.approvalValues.pending) {
				editsDone = true;
			}

			this.tabsData.tabs.forEach(function (d, i) {
				if (d.prop === 'myedits' && editsApproved) {
					d['done'] = true;
				}
				if (d.prop === 'myedits' && editsDone) {
					d['undone'] = true;
				}
			});
		} else {
			this.showApprovals = false;
		}
	}

	checkApprovalsStatus() {
		const persona = this.userService.persona;
		console.log('CHECK APPROVAL STATUS', persona, this.approvalFlags[persona], this.dataService.poContractorDetails, this.dataService.contractorDetails);
		if (this.approvalFlags[persona] !== undefined) {
			this.showApprovals = true;
			let contractorData = this.dataService.poContractorDetails;
			if (contractorData === null) {
				contractorData = this.dataService.contractorDetails;
			}
			let approvalsApproved = false;
			let approvalsDone = false;

			if (contractorData.approval[this.approvalFlags[persona].approvals] === this.approvalValues.approved) {
				approvalsApproved = true;
			}

			if (contractorData.approval[this.approvalFlags[persona].approvals] === this.approvalValues.pending) {
				approvalsDone = true;
			}

			this.tabsData.tabs.forEach(function (d, i) {
				if (d.prop === 'myapprovals' && approvalsApproved) {
					d['done'] = true;
				}
				if (d.prop === 'myapprovals' && approvalsDone) {
					d['undone'] = true;
				}
			});
		} else {
			this.showApprovals = false;
		}
	}

	loadAllforTab(tab) {
		if (tab.listTab) {
			switch (tab.type) {
				case 'standard':
					this.downloadContractorsForTab(tab);
					break;
				case 'po':
					this.loadPOContractorsForTab(tab, true);
					break;
			}
		}
	}

	loadContractorsForTab(tab, loadAll = false) {
		console.log('LOAD CONTRACTORS FOR TAB', tab, loadAll);
		this.loadContractors(tab, loadAll);
	}

	downloadContractorsForTab(tab) {
		console.log('DOWNLOAD CONTRACTORS FOR TAB', tab);
		this.commsService.downloadAllContractors(tab).subscribe((res) => {
			console.log('DOWNLOAD ALL CONTRACTORS RES: ', res);
			this.commsService.saveToCSV(tab.filename, res);
		}, (err) => {
			this.commsService.handleAPIError('Download All Contractors', err);
		});
	}

	loadPOContractorsForTab(tab, loadAll = false) {
		console.log('LOAD CONTRACTORS FOR TAB', tab, loadAll);
		this.loadPOContractors(this.activePO, tab, loadAll);
	}

	// UI INTERACTIONS

	openContractor(poNumber, contractorId, supplierId = '') {
		this.router.navigateByUrl(this.objRoot + '/' + poNumber + '/' + contractorId + '/' + supplierId);
	}

	tableClick(event) {
		console.log('CONT TABLE CLICK: ', event);
		const clickedRow = event.row;
		const poNumber = clickedRow[this.configService.poNumberProp];
		const contractorId = clickedRow[this.configService.contractorIdProp];
		const supplierId = clickedRow[this.configService.supplierIdProp];
		this.openContractor(poNumber, contractorId, supplierId);
	}

	tableSelect(event) {
		console.log('CONT TABLE SELECT: ', event, this.dataService.selectedTableRows);
		// for some reason this.dataService.selectedTableRows is not updated by select all
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('CONT TABLE REFRESH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadContractorsForTab(activeTab);
	}

	tablePage(event) {
		console.log('CONT TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.getActiveTab(this.tabsData.listTabs)['page'] = event.offset;
		this.loadContractorsForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(event, this.getActiveTab(this.tabsData.listTabs), (tab) => this.loadContractorsForTab(tab));
	}

	tableSearch(event) {
		console.log('CONT TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadContractorsForTab(activeTab);
	}

	poTablePage(event) {
		console.log('PO CONT TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.poListTabs);
		this.getActiveTab(this.tabsData.poListTabs)['page'] = event.offset;
		this.loadPOContractorsForTab(activeTab);
	}

	migrateTablePage(event) {
		console.log('PO CONT MIGRATE TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.migrateListTabs);
		this.getActiveTab(this.tabsData.migrateListTabs)['page'] = event.offset;
		this.updatePageDataForTab(activeTab);
	}


	// AUTOMATED PROCESSES

	fillAddonFields(contractorDetails) {
		console.log('FILL ADDON FIELDS', this.dataConfig, contractorDetails);
		try {
			if (contractorDetails[this.configService.contractorAddonsProp] === undefined || contractorDetails[this.configService.contractorAddonsProp] === null) {
				contractorDetails[this.configService.contractorAddonsProp] = {};
			}
		} catch (e) { }

		return contractorDetails;
	}

	updateEditing(editingId) {
		this.makingEdits = true;
		this.editingId = editingId;
		console.log('UPDATE EDITING', this.makingEdits, this.editingId);
	}

	resetEditing() {
		this.makingEdits = false;
		this.editingId = '';
		console.log('RESET EDITING', this.makingEdits, this.editingId);
	}

	updatePageDataForTab(tab) {
		const contractors = this.dataService.filteredPOContractorSelections;
		const dataRef = this.migrateDataObj + '-' + tab.prop + '-' + tab.type;
		const bIdx = tab.page * this.migratePageSize;
		const eIdx = (tab.page + 1) * this.migratePageSize >= contractors.length ? contractors.length : (tab.page + 1) * this.migratePageSize;
		this.dataService.updatePageData(dataRef, tab, contractors.slice(bIdx, eIdx));
		this.dataService.updateDataCount(dataRef, contractors.length);
	}
	getLineItemContractors(lineItemUUID) {
		const lineItemContractors = [];

		const self = this;
		this.dataService.poContractors.forEach(function (d, i) {
			if (d[self.configService.contractorLineItemProp] === lineItemUUID) {
				lineItemContractors.push(d);
			}
		});

		return lineItemContractors;
	}

	hasAddRoom(lineItemData) {

		let hasAddRoom = true;

		const lineItemUUID = lineItemData[this.configService.uuidProp];
		const totalLineItemContractors = this.getLineItemContractors(lineItemUUID).length;

		if (totalLineItemContractors > 0) {
			hasAddRoom = false;
		}

		return hasAddRoom;
	}

	canAddContractor() {
		let canAddContractor = false;

		const canSetBuyerId = this.configService.canDo(this.dataConfig['fields'], this.configService.buyerContractorId, 'edit');
		const canSetSupplierId = this.configService.canDo(this.dataConfig['fields'], this.configService.supplierContractorId, 'edit');

		if (canSetBuyerId || canSetSupplierId) {

			canAddContractor = true;

		}

		return canAddContractor;
	}

	checkShowForm() {
		if (this.userService.persona.toLowerCase() !== 'sam') {
			return true;
		} else {
			try {
				return this.dataService.invoiceCalendars[0]['id'] !== undefined;
			} catch (e) {
				return false;
			}
		}
	}

	checkShowFormError() {
		if (this.userService.persona.toLowerCase() !== 'sam') {
			return false;
		} else {
			try {
				return this.dataService.invoiceCalendars[0]['id'] === undefined;
			} catch (e) {
				return true;
			}
		}
	}

	populateTimesheetsRange(contractorData) {

		const timesheetsRange = {};
		const rangeConfig = this.configService.getDataObj(this.configService.timesheetsRangeDataObj);
		const self = this;

		/*
		Use autoPop from config files to grab from po data or po contractor item
		*/
		rangeConfig.fields.forEach(function (d, i) {
			// console.log('NEW CONTRACTOR FIELD:', d.prop);
			if (d.autoPop === '') {
				rangeConfig[d.prop] = '';
			} else {
				const popArr = d.autoPop.split(':');
				if (popArr[2] === undefined) {
					timesheetsRange[d.prop] = contractorData[popArr[1]];
				}
				if (popArr[2] !== undefined && popArr[3] === undefined) {
					timesheetsRange[d.prop] = contractorData[popArr[2]];
				}
				if (popArr[3] !== undefined) {
					timesheetsRange[d.prop] = contractorData[popArr[2]][popArr[3]];
				}
			}
		});

		// populate default range of one year
		/*const date = new Date();
		timesheetsRange[this.configService.endDateProp] = this.dataService.formatDate(date);
		date.setMonth(date.getMonth() - 12);
		timesheetsRange[this.configService.startDateProp] = this.dataService.formatDate(date);
		*/
		timesheetsRange[this.configService.endDateProp] = this.dataService.formatDate(new Date(contractorData[this.configService.contractorEndProp]));
		timesheetsRange[this.configService.startDateProp] = this.dataService.formatDate(new Date(contractorData[this.configService.contractorStartProp]));

		console.log('ONE YEAR', timesheetsRange['startdate'], timesheetsRange['enddate']);

		console.log('POP TIMESHEETS RANGE', timesheetsRange);

		this.dataService.updateTimesheetsRange(timesheetsRange);
	}

	//
	// API CALLS
	//

	loadContractor(poNumber, contractorId, supplierId) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.getContractorDetails(poNumber, contractorId, supplierId).subscribe((res) => {
			this.displayService.endLoading();
			console.log('LOAD CONTRACTOR RES: ', res);

			let successData = self.commsService.getSuccessData(res);
			successData = self.parseEmails(successData);
			successData = self.parseApprovalDate(successData);
			// API /getcontractor will returns the empty accounts array in contractor json after
			// supporting ilc search
			// const contractorAccounts = successData[self.configService.accountsProp];
			// const contractorNodes = self.accountService.nodesFromAccounts(contractorAccounts);
			successData = self.fillAddonFields(successData);
			successData = self.updateContractorByCountrycode(successData);
			self.dataService.updateContractorDetails(successData);
			self.populateTimesheetsRange(successData);
			self.dataService.updateMinMaxDates();
			self.checkTabs(self.tabsData.tabs);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load Contractor', err);
		});
	}

	loadContractors(data, loadAll = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
		}
		this.commsService.getContractorList(data, loadAll).subscribe((res) => {
			console.log('LOAD CONTRACTORS RES: ', res);
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			let contractors = [];
			if (Array.isArray(successData) && successData.length > 0) {
				contractors = successData;
				try {
					contractors.forEach(contractor => {
						self._parseContractor(contractor);
					});
				} catch (error) {
					console.error('Error occurred during retrieving pm/sam/dtvemail from acl');
				}
			}
			if (!loadAll) {
				const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
				self.dataService.updatePageData(dataRef, data, contractors);
				self.dataService.updateDataCount(dataRef, count);
			} else {
				self.dataService.broadcastLoadAll(contractors);
			}

		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);
			}
			self.commsService.handleAPIError('Load Contractors', err);
		});
	}

	_parseContractor(contractor) {
		this.parseEmails(contractor);
		contractor.conemail = contractor.acl.contractor.participants[0];
		if (!contractor[this.configService.contractorILCProp] && contractor[this.configService.ilcSerialNumProp]) {
			contractor[this.configService.ilcSerialNumProp] = '';
		}
	}

	parseEmails(contractor) {
		contractor.pmemail = contractor.acl.pm.participants[0];
		contractor.samemail = contractor.acl.sam.participants[0];
		contractor.traemail = contractor.acl.tra.participants[0];
		contractor.acltra = contractor.acl.tra.participants[0];
		return contractor;
	}

	parseApprovalDate(contractor) {
		const approvalDateTime = contractor.approval.approvaldatetime;
		if (approvalDateTime) {
			contractor['approvaldate'] = this.dataService.formatDateFromString(approvalDateTime);
		}
		return contractor;
	}

	updateContractorByCountrycode(contractorDetails) {
		let isNew = false;
		const countryCode = contractorDetails[this.configService.countryCodeProp];
		if (!contractorDetails['contractorcountrycode']) {
			contractorDetails['contractorcountrycode'] = countryCode;
			isNew = true;
		}

		Object.keys(this.configService.countryCodes).forEach( (key) =>{
			contractorDetails[key] = false;
			if (!countryCode) {
				if (key === 'US') {
					contractorDetails[key] = true;
				} 
			} else {
				if (this.configService.countryCodes[key].indexOf(countryCode) >= 0) {
					contractorDetails[key] = true;
					// need set the default countryCode as contractorcountrycode if there are multiple like IE
					if (isNew && this.configService.countryCodes[key].indexOf(',') > 0 && this.configService.countryCodes[key].indexOf(countryCode) > 0) {
						contractorDetails['contractorcountrycode'] = this.configService.countryCodes[key].split(',')[0];
					}
				}
			}
		});
		return contractorDetails;
	}

	// need a new API to replace the filter by email, ponum and status
	loadContractorsForMigrateTS(data, email, ponum) {
		const self = this;
		this.loadingMigrateContractors = true;
		data[this.configService.buyercontractoremail] = email;
		this.commsService.getContractorList(data, true).subscribe((res) => {
			console.log('LOAD CONTRACTORS RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			let contractors = [];
			if (Array.isArray(successData) && successData.length > 0) {
				try {
					contractors = successData.filter(contractor => {
						if (contractor['warranty'] || contractor['cancellation']) {
							return false;
						} else {
							const isReturn = contractor[self.configService.poNumberProp] !== ponum &&
								contractor[self.configService.contractorEditcodeProp] === '1111' &&
								new Date(contractor[self.configService.contractorEndProp]) >= new Date();
							return isReturn;
						}
					});
				} catch (error) {
					console.error('Error occurred during retrieving contractor email from acl');
				}
			}
			const dataRef = self.migrateTSDataObj + '-' + data.prop + '-' + data.type;
			self.dataService.data[self.migrateTSDataObj] = contractors;
			self.dataService.updatePageData(dataRef, data, contractors);
			self.dataService.updateDataCount(dataRef, contractors.length);
			self.loadingMigrateContractors = false;
		}, (err) => {
			self.commsService.handleAPIError('Load Contractors for migrating timesheets', err);
			this.loadingMigrateContractors = false;
		});
	}

	loadPOContractors(poNumber, data, loadAll = false, prev = false) {
		const self = this;
		if (!loadAll) {
			// this.displayService.startLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.poListTabs);
		}
		if (prev) {
			this.loadingMigrateContractors = true;
		}
		this.commsService.getPOContractorList(poNumber, data.prop).subscribe((res) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.poListTabs);
			}
			console.log('LOAD PO CONTRACTORS RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			let contractors = [];
			if (Array.isArray(successData) && successData.length > 0) {
				contractors = successData;
				try {
					contractors.forEach(contractor => {
						this._parseContractor(contractor);
					});
				} catch (error) {
					console.error('Error occurred retrieving pm/sam/dtvemail from acl for contractor');
				}
			}
			if (prev) {
				self.dataService.updatePOContractorSelections(contractors);
				this.selectDefaultTab(this.tabsData.migrateListTabs);
				this.loadingMigrateContractors = false;
			} else {
				if (!loadAll) {
					const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
					self.dataService.updatePageData(dataRef, data, contractors);
					self.dataService.updateDataCount(dataRef, count);
				} else {
					self.dataService.broadcastLoadAll(contractors);

					// Required for newcontractor race scenario
					// New contractor submit waits for callback after reloading po contractors
					if (data.prop === self.getPOAllTab().prop) {
						self.dataService.updatePOContractors(contractors);
						self.dataService.broadcastPOContractors();
					}

					// Required to stay on given contractor after submitting edits or approval
					if (data.prop === self.getPOPendingTab().prop) {
						self.dataService.updatePOPendingContractors(contractors);
						self.dataService.broadcastPOPendingContractors();
					}

				}
			}
		}, (err) => {
			if (!loadAll) {
				// self.displayService.endLoading();
				this.displayService.deactivateLoadingTab(data, this.tabsData.poListTabs);
			}
			if (prev) {
				this.loadingMigrateContractors = false;
			}
			self.commsService.handleAPIError('Load PO Contractors', err);
		});
	}

	loadPrevPOContractors(poNumber, supplierId) {
		const self = this;
		// need load PO first to see if it is a renewal PO
		this.commsService.getPODetails(poNumber, supplierId).subscribe((res) => {
			console.log('LOAD PO RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			self.dataService.updatePODetails(successData);
			if (successData.renewalpo) {
				// load the contractors of the previous PO for migrating
				// if prevponum === '', API will return all contractors
				self.loadPOContractors(successData.prevponum, this.getPOAllTab(), true, true);
			} else {
				self.dataService.updatePOContractorSelections([]);
			}
		}, (err) => {
			self.commsService.handleAPIError('Load Previous PO Contractors', err);
			self.router.navigateByUrl(this.listRoot);
		});
	}

	submitNewContractor(origin) {
		const self = this;

		this.dataService.newContractorDetails['accounts'] = this.accountService.getAccountsFromNodes(this.dataService.contractorNodes);
		const newContractorDetails = this.dataService.newContractorDetails;

		console.log('SUBMIT NEW CONTRACTOR', newContractorDetails);

		this.addonService.updateUsedAddons(newContractorDetails[this.configService.contractorAddonsProp]);

		this.displayService.startLoading();
		this.commsService.sendNewContractor(newContractorDetails).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('The contractor record has been submitted successfully.');
			console.log('SEND NEW CONTRACTOR RES: ', res);

			const successData = this.commsService.getSuccessData(res);
			self.dataService.updateNewContractorDetails(null);
			origin.contractorSuccess();
			// self.dataService.broadcastNotifications(self.dataObj);

		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('Submit New Contractor', err);
		});
	}

	submitContractor(origin, data, originalData) {
		const self = this;

		console.log('SUBMIT CONTRACTOR', data, originalData);

		const newContractorDetails = this.commsService.getTrimmedPayload(this.dataConfig, data, originalData);

		this.addonService.updateUsedAddons(newContractorDetails[this.configService.contractorAddonsProp]);

		this.displayService.startLoading();
		this.commsService.sendContractor(newContractorDetails).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess('The contractor record edits have been submitted successfully.');
			console.log('SEND CONTRACTOR RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			self.dataService.updatePOContractorDetails(null);
			origin.contractorSuccess();
			self.dataService.broadcastNotifications(self.dataObj);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Submit Contractor Edits', err);
		});
	}

	approveContractor(poNumber, contractorId, supplierId, approvalstatus, origin) {
		const self = this;
		let successMsg = 'The contractor record approval status has successfully been updated to ' + approvalstatus + '.';
		let errorMsg = 'Approve Contractor';
		if (approvalstatus === 'rejected') {
			successMsg = 'The proposal to enact the warranty on this contractor has been successfully rejected.';
			errorMsg = 'Reject Contractor Warranty';
		}

		this.displayService.startLoading();
		this.commsService.approveContractor(poNumber, contractorId, supplierId, approvalstatus).subscribe((res) => {
			self.displayService.endLoading();
			self.noteService.displaySuccess(successMsg);

			console.log('APPROVE CONTRACTOR RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			self.dataService.updatePOContractorDetails(null);
			origin.contractorSuccess();
			const delay = setTimeout(function () {
				self.dataService.broadcastNotifications(self.dataObj);
			}, 4000);

		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError(errorMsg, err);
		});
	}

	getContractorPOs() {
		const self = this;
		this.commsService.getUserKeys().subscribe((res) => {
			const jsonRes = res.detail;
			self.awaitingContractorPOs = false;
			const poNumber = jsonRes[0][this.configService.poNumberProp];
			this.configService.supplierId = jsonRes[0][this.configService.supplierIdProp];
			this.dataService.setUserKeys(jsonRes);
			// non-approved contractor will get empty detail
			if (jsonRes && jsonRes.length > 1) {
				// if contractor has more than one POs, need build a jason to map ponumber to its poObject
				jsonRes.sort((a, b) => {
					if (a.actualenddate < b.actualenddate) {
						return 1;
					}
					if (a.actualenddate > b.actualenddate) {
						return -1;
					}
					return 0;
				});
				self.loadContractorPOsCompleted.emit({});
			} else {
				self.dataService.contractorPOs = [];
				self.dataService.selectedPO = {
					name: poNumber,
					prop: poNumber
				};
			}
		}, (err) => {
			self.dataService.contractorPOs = [];
			self.dataService.selectedPO = null;
			self.awaitingContractorPOs = false;
			console.error('failed to retrieve POs for contractor');
		});
	}

	loadContractorPOsListener() {
		return this.loadContractorPOsCompleted;
	}

	handlePartialSuccess(res) {
		this.showErrorContractors = true;
		this.showSuccessContractors = false;
		const error = res.error;

		this.configService.resetTempTab();
		const tempTab = this.configService.tempTab;

		const errorRes = this.commsService.getPartialError(error);
		const errorCount = this.commsService.getSuccessCount(errorRes);
		const errorDataRef = this.errorDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(errorDataRef, tempTab, errorRes);
		this.dataService.updateDataCount(errorDataRef, errorCount);

		const successRes = this.commsService.getPartialSuccess(error);
		const successCount = this.commsService.getSuccessCount(successRes);
		const successDataRef = this.successDataObj + '-' + tempTab.prop + '-' + tempTab.type;
		this.dataService.updatePageData(successDataRef, tempTab, successRes);
		this.dataService.updateDataCount(successDataRef, successCount);

		if (this.dataService.pageData[successDataRef][0].length > 0) {
			this.showSuccessContractors = true;
		}
		// console.log('PARITAL SUCCESS CONTRACTORS', this.dataService.pageData[errorDataRef][0], this.dataService.pageData[successDataRef][0]);
	}

	cancelPartialSucessModal(event) {
		this.showErrorContractors = false;
		this.showSuccessContractors = false;
	}

	/**
	 * Gets the csv file and checks if it exists and if the extension is valid. 
	 * Turns csv file into 2d array and does validations (correct headers, and if empty)
	 * @param files
	 * @returns 2d array with the information of the csv file
	 */
	 uploadContractors(files) {
		this.files = files;
		const reader = new FileReader();
		if(!files) {
			this.fileUploadMessage = 'Error processing file. No file chosen';
			this.fileUploadSuccessMessage = '';	
			return;
		} else if (!files[0].name.endsWith('.csv')) {
			this.fileUploadMessage = 'Error processing file. File must be a csv (comma separated values) with the extension of .csv';
			this.fileUploadSuccessMessage = '';
			return;
		} 

		reader.readAsText(files[0]);
		reader.onload = (e: any) => {
			const result = reader.result;
			const arr = result.toString().split(/\r?\n/).map(function(line) {
				let rgx1 = "/^\s+|\s+$/g";
				let rgx2 = "/\s*,\s*/";
				return line.replace(rgx1, '').split(rgx2);
			});
			this.csvValidation(arr);
		};
	}

	csvValidation(arr) {
		if(!arr) {
			this.fileUploadMessage = 'Error processing file. File must be a csv (comma separated values) with the extension of .csv';
			this.fileUploadSuccessMessage = '';
		} else {
			if(arr.length < 1 || arr[0].length < 7 || arr[0][0].toLowerCase() != 'po number' || arr[0][1].toLocaleLowerCase() != 'serial' || 
			arr[0][2].toLocaleLowerCase() != 'country code' || arr[0][3].toLocaleLowerCase() != 'contractor email' || 
			arr[0][4].toLocaleLowerCase() != 'ilc enabled' || arr[0][5].toLocaleLowerCase() != 'ilc serial' || 
			arr[0][6].toLocaleLowerCase() != 'manager email') {
				this.fileUploadMessage = 'Error processing file. Use the provided template or make sure the headers are correct';
				this.fileUploadSuccessMessage = '';
			} else if(arr.length <= 1 || arr[1].length == 0) {
				this.fileUploadMessage = 'Error processing file. Empty file';
				this.fileUploadSuccessMessage = '';
			} else {
				this.fileUploadSuccessMessage = 'File uploaded successfully';
				this.fileUploadMessage = '';
			}
		}

		const data = arr;

		if (this.fileUploadSuccessMessage) {
			for (let i = 0; i < data.length; i++) {
				const line = data[i];
				if(line.every(element => element === '')) {
					data.splice(i, 1);
					i--;
				}
			}
		}

		this.contractorBulkData = data;
	}

	resetUploadContractors() {
		this.files = undefined; 
		this.fileUploadMessage = '';
		this.fileUploadSuccessMessage = '';
	}

	submitContractorBulk() {
		this.displayService.startLoading();

		const data = this.contractorBulkData;
		this.commsService.sendContractorRecords(data).subscribe((res) => {
			this.displayService.endLoading();
			let successMsg = 'The Contractor Record(s) has been successfully submitted. An email will be sent with the status of your request.';
			if (res.message) {
				successMsg = res.message; 
			}
			this.fileUploadMessage = '';
			this.fileUploadSuccessMessage = successMsg;
			this.noteService.displaySuccess(successMsg);
			this.showContractorSubmissionModal = false;
		}, (err) => {
			this.displayService.endLoading();
			console.log('CONTRACTOR BULK RECORD RES', err);
			this.fileUploadMessage = 'Creation of Contractor Record(s) Error: ' + err.error.message;
			this.fileUploadSuccessMessage = '';
			this.commsService.handleAPIError('Creation of Contractor Record(s)', err);
		});
	}

}
